module.exports = __webpack_public_path__ + "ba.no2.6b47c170.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/okuta/child_to_parent/ba.no2.jpg
// module id = MLld
// module chunks = 0